import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext'; // Import Language Context

const ContactUs = () => {
  const { language } = useLanguage(); // Access the language context
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <section 
      className="flex flex-col items-center text-center py-12 px-4 md:px-8 lg:px-12 bg-gray-100 rounded-lg shadow-md mt-12"
      aria-labelledby="contact-us-heading"
    >
      <p 
        className="text-lg md:text-xl text-gray-700 mb-6 max-w-xl"
        aria-label={
          language === 'English'
            ? 'Encouragement message to join the cause and contact staff.'
            : 'Mesazh inkurajimi për t’iu bashkuar kauzës dhe kontaktuar stafin.'
        }
      >
        {language === 'English'
          ? 'Want to join our cause? Discover how by contacting our team.'
          : 'Doni t’i bashkoheni kauzës sonë? Zbuloni si duke kontaktuar stafin tonë.'}
      </p>
      <button
        onClick={handleContactClick}
        className="bg-gray-900 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded-full text-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        aria-label={
          language === 'English'
            ? 'Navigate to the Contact Us page'
            : 'Shkoni tek faqja e Kontaktit'
        }
      >
        {language === 'English' ? 'Contact Us' : 'Na kontaktoni'}
      </button>
    </section>
  );
};

export default ContactUs;